import { DataBean } from "../DataBean";

export class ConsolidatePACbycache extends DataBean {


    public async getConsolidatePACCatalogPorPropiedadesRender(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.List_getConsolidatePACCatalogPorPropiedadesRender_java.util.Map_Number", [properties,maxRows]);
    }


 
}